module.exports = __webpack_public_path__ + "static/media/cover-image.6a2b7a16.jpg";